// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!

/* tslint:disable */
export const VERSION = {
  version: "7.10.0",
  date: "2026-09-23T08:52:18.443Z",
  gitInfo: {
    dirty: false,
    raw: "1b8d81470",
    hash: "1b8d81470",
    distance: null,
    tag: null,
    semver: null,
    suffix: "1b8d81470",
    semverString: null
  }
};
/* tslint:enable */
